import React, { createContext, useContext, useState } from "react";

const AdminCompanyContext = createContext();

export default function AdminCompanyProvider({ children }) {
  const [adminCompCode, setAdminCompCode] = useState("");
  const [adminCompName, setAdminCompName] = useState("");

    const [adminSiteCode, setAdminSiteCode] = useState(null);
    const [adminSiteName, setAdminSiteName] = useState("");
  return (
    <AdminCompanyContext.Provider value={{ adminCompCode, setAdminCompCode, adminCompName, setAdminCompName, adminSiteCode, setAdminSiteCode, adminSiteName, setAdminSiteName }}>
      {children}
    </AdminCompanyContext.Provider>
  );
}

export function useAdminCompany() {
  return useContext(AdminCompanyContext);
}
